import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { trendData } from "@home3/homeType";
import t201 from "/public/images/t2_01.png";
import t202 from "/public/images/t2_02.png";
import t203 from "/public/images/t2_03.png";
import t204 from "/public/images/t2_04.png";
import buriedSdk from '@/utils/zz-buried/index'

type Props = {
  
};
let chartCard: any = null;
const data = [
    { time: "10:10", call: 4, waiting: 2, people: 2 },
    { time: "10:15", call: 2, waiting: 6, people: 3 },
    { time: "10:20", call: 13, waiting: 2, people: 5 },
    { time: "10:25", call: 9, waiting: 9, people: 1 },
    { time: "10:30", call: 5, waiting: 2, people: 3 },
    { time: "10:35", call: 8, waiting: 2, people: 1 },
    { time: "10:40", call: 13, waiting: 1, people: 2 },
];
const Index = (props: Props) => {
    const { t, i18n } = useTranslation(["home"]);
    // const dom:any = useRef()
    // useEffect(()=> {
    //     if (dom.current && !chartCard) {
    //         chartInit(dom.current)
    //     }
    // }, [dom])
    const pcUrl = process.env.portalUrl;
    return (
        <div className={`${styles.ecomTrend} bg-[#fff]`}>
            <div className="defeaultContainer">
                <div className="flex justify-between items-center pt-[50px]">
                    <h2 className={styles.title}>{t("ecomTrend")}</h2>
                    <div>
                        <a
                            target="_self"
                            href={pcUrl + "/home"}
                            rel="noreferrer"
                            onClick={()=>{
                                buriedSdk.buried({
                                    event: `Shoplus官网_Web`,
                                    scene: `Weekly TikTok Ecom Trending_View More Data`,
                                    URL: process.env.publicApiDomain,
                                });
                            }}
                            className={`${styles["viewbtn"]} flex justify-center items-center`}
                        >
                            {t('View More Data')}
                        </a>
                    </div>
                </div>

                <div className={styles.time}>{t("update12hour")}</div>
                <div className={`${styles["fix-box"]} `}>
                    <div className={`${styles["card-info"]}`}>
                        <div className={`${styles["card-item"]}`}>
                            <div className={`${styles["card-item-i"]}`}>
                                <div className={styles["card-title"]}>
                                    <span className={styles["t-img"]}>
                                        <Image src={t201}></Image>
                                    </span>
                                    <span>{t('Revenue')}</span>
                                </div>
                                <div
                                    id="js1-bounty"
                                    className={`${styles["card-desc"]} animate-box  cm-in-number js1-bounty`}
                                ></div>
                            </div>
                        </div>
                        <div className={`${styles["card-item"]}`}>
                            <div className={`${styles["card-item-i"]}`}>
                                <div className={styles["card-title"]}>
                                    <span className={styles["t-img"]}>
                                        <Image src={t202}></Image>
                                    </span>
                                    <span>{t('Sales Volume')}</span>
                                </div>
                                <div
                                    id="js2-bounty"
                                    className={`${styles["card-desc"]} animate-box  cm-in-number js2-bounty`}
                                ></div>
                            </div>
                        </div>
                        <div className={`${styles["card-item"]}`}>
                            <div className={`${styles["card-item-i"]}`}>
                                <div className={styles["card-title"]}>
                                    <span className={styles["t-img"]}>
                                        <Image src={t203}></Image>
                                    </span>
                                    <span>{t('Products')}</span>
                                </div>
                                <div
                                    id="js3-bounty"
                                    className={`${styles["card-desc"]} animate-box  cm-in-number js3-bounty`}
                                ></div>
                            </div>
                        </div>
                        <div className={`${styles["card-item"]}`}>
                            <div className={`${styles["card-item-i"]}`}>
                                <div className={styles["card-title"]}>
                                    <span className={styles["t-img"]}>
                                        <Image src={t204}></Image>
                                    </span>
                                    <span>{t('Views')}</span>
                                </div>
                                <div
                                    id="js4-bounty"
                                    className={`${styles["card-desc"]} animate-box  cm-in-number js4-bounty`}
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div className={styles["chart-legend"]}>
                        <div className={styles["chart-i"]}>{t('Sales Volume')}</div>
                        <div className={styles["chart-i"]}>{t('Total Volume')}</div>
                    </div>
                    <div
                        className={`${styles["chart-card"]} animate-box cm-in-chart`}
                    ></div>
                    <div className={styles["chart-pd"]}></div>
                </div>
            </div>
        </div>
    );
};
export default Index;
